<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="flex-start center" class="my-1 px-1" *ngIf="!!featureTags && featureTags['ftag_sf_card_expiry2']" >
        <p *ngFor="let card of creditCards" style=" color: rgb(198, 40, 40);
    font-weight:450;">
            <span *ngIf="card.is_card_expired && card.default">Your default card has expired. Update it to avoid issues.</span>
            <span *ngIf="!card.is_card_expired && card.decline_count > 1 && card.default">Your default card is declining. Update it or add a new card.</span>
        </p>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="mt-1 px-1">
        <h2 class="text-muted text-center">
            Manage Payment Options
        </h2>
    </div>
    <ng-container *ngIf="!!featureTags && featureTags['ftag_cod_and_other_payment_for_sf']">
        <div class="payment-options">
                <mat-radio-button (change)="selectPaymentMethod($event)" class="radio-button" 
                value="Credit Card" [checked]="selectedPaymentMethod === 'Credit Card'">
                    <span class="radio-label" style="font-size: 16px; font-weight: bold;">Credit & Debit Cards</span>
                </mat-radio-button>
        </div>
    </ng-container>
      
    <div *ngIf="!!creditCards && !creditCardsNotFound;" class="px-1">
        <div class="mt-1" fxLayout="row warp">
            <mat-card class="creditCard" *ngFor="let card of creditCards" fxFlex="100"
                [class.default]="card.default">
                <div fxLayout="column">
                    <p>
                        {{card.cardType | titlecase}}&nbsp;
                        ****&nbsp;{{card.last4}}&nbsp;
                        {{card.default ? '(Default Payment Method)' : ''}}
                    </p>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-1">
                        <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="20px">
                        <p>Expires on {{card.expirydate}}</p>
                            <div *ngIf="!!featureTags && featureTags['ftag_sf_card_expiry2']" >
                                <p *ngIf="card.is_card_expired" class="expireStyle">Expired Card</p>
                                <p *ngIf="!card.is_card_expired && card.decline_count > 1" class="expireStyle">Card Declining</p>
                            </div>
                        </div>
                            
                        <mat-icon class="mat-icon-md creditCardAction" mat-button 
                            [matMenuTriggerFor]="creditCardAction">
                            more_vert
                        </mat-icon>
                    </div>
                    <mat-menu #creditCardAction="matMenu">
                        <button mat-menu-item [disabled]="card.default"
                            (click)="setDefaultCreditCard(card.id)">
                            Set as Default
                        </button>
                        <button mat-menu-item
                            (click)="editCreditCard(card)">
                            Edit
                        </button>
                        <button mat-menu-item
                            (click)="deleteCreditCard(card.id, card['default'])">
                            Delete
                        </button>
                    </mat-menu>
                </div>
            </mat-card>
        </div>
    </div>
    <div fxFlex="100" fxLayout="column" fxLayoutAlign="center center" class="py-2"
        *ngIf="creditCardsNotFound">
        <h4 class="text-muted">*No credit card found!</h4>
    </div>
    <div fxFlex.gt-xs="100" fxLayout="column" fxLayoutAlign="center flex-end" class="p-1 bottom-border">
        <button mat-raised-button class="add-new-credit-card-btn"
        routerLink="/account/payment/add-credit-card" [ngStyle.xs]="{'width.%':100}">
            <span>
                <mat-icon class="mat-icon-sm">
                    add
                </mat-icon>
                Add a New Credit Card
            </span>
            <mat-icon class="mat-icon-md">
                keyboard_arrow_right
            </mat-icon>
        </button>
    </div>
    <ng-container *ngIf="!!featureTags && featureTags['ftag_cod_and_other_payment_for_sf']">
        <mat-card class="creditCard" fxFlex="100" *ngIf="!!paymentCashOnDelivery && !!paymentCashOnDelivery.is_sf_active">
                <div class="payment-options">
                    <mat-radio-button value="cod" class="radio-button" (change)="selectPaymentMethod($event)"
                    value="Cash On Delivery" [checked]="selectedPaymentMethod === 'Cash On Delivery'">
                    <div fxLayout="column">
                        <p style="font-size: 16px; font-weight: bold;">Cash on Delivery</p>
                    </div>
                </mat-radio-button>
                <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-left: 20px;">
                    <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="20px">
                        <p>Pay later at your doorstep with Cash on Delivery.</p>
                    </div>
                </div>
            </div>
        </mat-card>
    </ng-container>
    <ng-container *ngIf="!!featureTags && featureTags['ftag_pay_with_store_credit_design_feature_in_sf']">
        <div class="store-credit-div">
            <div>Store Credit</div>
            <div>{{ userDetailsForStoreCredit?.currency || '' }}{{ (userDetailsForStoreCredit?.instore_credit_amount || 0) | number:'1.2-2' }}</div>
        </div>
    </ng-container>        
</div>
